<div class="max-loan-bal-ho-container">
  <div class="modal-body">
    <label>Maximum Loan Balance Question</label>
    <br />
    <br />
    <i class="fa fa-info-circle" aria-hidden="true"></i>&nbsp;
    <b>To provide maximum balances of related party amounts loaned and borrowed for Form 5471 Schedule M</b>
    <br />
    <br />
    <div>
      <table class="table table-bordered custom-table text">
        <thead style="text-align: center">
          <tr>
            <th>Account Code</th>
            <th>Account Description</th>
            <th>Amount</th>
            <th>Maximum Balance during year, if different</th>
          </tr>
        </thead>
        <tbody>
          @for (item of maxLoanTableData; track $index) {
<tr>
            <td>{{ item.acc_code }}</td>
            <td>{{ item.acc_desc }}</td>
            <td class="text-right">{{ item.amount }}</td>
            <td>
              <input type="text" class="form-control text-right" [(ngModel)]="item.maxBalance" />
            </td>
          </tr>
}
          <tr>
            <td><b>Total</b></td>
            <td></td>
            <td class="text-right"><b>{{ totalAmount }}</b></td>
            <td class="text-right"><b>{{ totalMaxBalance }}</b></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="paddingTop">
      <button type="button" class="save-button" [disabled]="isSaveClicked" (click)="save()">Save</button>
    </div>
  </div>
</div>
